import { useEffect, useRef, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { Droplets, CheckCircle2 } from "lucide-react";
import api from "@/lib/api";

const STORAGE_KEY = "aware_referral";

export default function ReferralLanding() {
  const { slug } = useParams();
  const navigate = useNavigate();
  const [businessName, setBusinessName] = useState(null);
  const firedRef = useRef(false);

  useEffect(() => {
    // StrictMode double-mount guard — record the visit exactly once.
    if (firedRef.current) return;
    firedRef.current = true;
    let cancelled = false;
    api.post(`/referral-links/${encodeURIComponent(slug)}/visit`)
      .then(({ data }) => {
        if (cancelled) return;
        try {
          localStorage.setItem(STORAGE_KEY, JSON.stringify({
            slug, business_name: data.business_name, at: Date.now(),
          }));
        } catch { /* private mode */ }
        setBusinessName(data.business_name);
        setTimeout(() => navigate("/book", { replace: true }), 1600);
      })
      .catch(() => navigate("/book", { replace: true }));
    return () => { cancelled = true; };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [slug]);

  return (
    <div data-testid="referral-landing" className="min-h-screen bg-slate-900 flex items-center justify-center px-4">
      <div className="text-center max-w-sm">
        <div className="w-14 h-14 rounded-2xl bg-cyan-500/20 flex items-center justify-center mx-auto">
          <Droplets className="w-7 h-7 text-cyan-400" />
        </div>
        <h1 className="font-display mt-5 text-2xl font-bold text-white">Aware Water Testing</h1>
        {businessName ? (
          <p data-testid="referral-landing-partner" className="mt-3 text-slate-300 text-sm inline-flex items-center gap-1.5">
            <CheckCircle2 className="w-4 h-4 text-cyan-400" />
            Referred by <span className="font-semibold text-white">{businessName}</span>
          </p>
        ) : (
          <p className="mt-3 text-slate-400 text-sm">Loading your booking…</p>
        )}
        <p className="mt-2 text-xs text-slate-500">Taking you to the booking page…</p>
      </div>
    </div>
  );
}
